import manifest from '../../levels/manifest.json';
import { parseLevel, type Level, type RawLevel } from '../core/level';

export interface ZoneMeta {
  id: string;
  name: string;
  theme: string;
}

export interface LevelMeta {
  id: string;
  name: string;
  file: string;
  overworld: { x: number; y: number };
  zone: string;
}

// Auto-discover every level JSON; the manifest decides order, zones + metadata. Adding a
// level = drop levels/<id>.json + one manifest entry (no code change here).
const rawModules = import.meta.glob<{ default: RawLevel }>('../../levels/*.json', {
  eager: true,
});

export const ZONES: ZoneMeta[] = manifest.zones as ZoneMeta[];

export interface LevelEntry extends LevelMeta {
  raw: RawLevel;
  zoneName: string;
  theme: string;
}

function loadEntries(): LevelEntry[] {
  return (manifest.levels as LevelMeta[]).map((m) => {
    const mod = rawModules[`../../levels/${m.file}`];
    if (!mod) throw new Error(`manifest references missing level file: ${m.file}`);
    const zone = ZONES.find((z) => z.id === m.zone);
    if (!zone) throw new Error(`level "${m.id}" references unknown zone "${m.zone}"`);
    return { ...m, raw: mod.default, zoneName: zone.name, theme: zone.theme };
  });
}

export const LEVELS: LevelEntry[] = loadEntries();
export const LEVEL_IDS: string[] = LEVELS.map((l) => l.id);

/** Levels belonging to a zone, in manifest order. */
export function zoneLevels(zoneId: string): LevelEntry[] {
  return LEVELS.filter((l) => l.zone === zoneId);
}

export function buildLevel(entry: LevelEntry): Level {
  return parseLevel(entry.raw);
}
